import React from 'react'
import { useTranslatedText } from '../OracleCommons/StaticTextContext'

interface OracleRateLimitMessageProps {
  className?: string
  limitType?: string | null
}

const OracleRateLimitMessage: React.FC<OracleRateLimitMessageProps> = ({
  className = '',
  limitType,
}) => {
  // Get translated text for rate limit messages
  const limitReachedMessage = useTranslatedText({ keys: ['rateLimit', 'limitReachedMessage'] })
  const limitReachedContact = useTranslatedText({ keys: ['rateLimit', 'limitReachedContact'] })
  const limitReachedLink = useTranslatedText({ keys: ['rateLimit', 'limitReachedLink'] })
  const limitReachedEnd = useTranslatedText({ keys: ['rateLimit', 'limitReachedEnd'] })
  const trialLimitReachedBefore = useTranslatedText({ keys: ['rateLimit', 'trialLimitReachedBefore'] })
  const trialLimitReachedLink = useTranslatedText({ keys: ['rateLimit', 'trialLimitReachedLink'] })
  const trialLimitReachedAfter = useTranslatedText({ keys: ['rateLimit', 'trialLimitReachedAfter'] })

  // Support URL
  const supportUrl = 'https://gaiasupportcenter.zendesk.com/hc/en-us/requests/new'
  const upgradeUrl = '/account'

  if (limitType === 'lifetime') {
    return (
      <div className={`oracle-rate-limit-message ${className}`}>
        <p>
          {trialLimitReachedBefore}
          <a href={upgradeUrl}>{trialLimitReachedLink}</a>
          {trialLimitReachedAfter}
        </p>
      </div>
    )
  }

  return (
    <div className={`oracle-rate-limit-message ${className}`}>
      <p>{limitReachedMessage}</p>
      <p>
        {limitReachedContact} <a href={supportUrl} target="_blank" rel="noopener noreferrer">{limitReachedLink}</a>{limitReachedEnd}
      </p>
    </div>
  )
}

export default OracleRateLimitMessage
